import React, { FC } from 'react';
import styled from 'styled-components';
import { Text } from 'src/components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { ContentWrapper } from 'components/content-wrapper/ContentWrapper';
import { colors } from 'src/styles/colors';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { AuthenticationStepKey } from 'logic/store/authentication/authentication.model';
import { useRedirectToPublishOffer } from 'logic/store/offer/offer.hooks';
import Button from 'antd/lib/button';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;
const TextWrapper = styled.div<{ mobile: boolean }>`
  text-align: center;
  display: flex;
  flex-direction: column;
`;

export const RegisterSection: FC = () => {
  const { minTablet } = useBreakpoints();
  const createOffer = useRedirectToPublishOffer(AuthenticationStepKey.RegisterWithEmail);

  return (
    <ContentWrapper backgroundColor={colors.lightTeal} padding={minTablet ? '74px 0' : '64px 0'}>
      <Content>
        <TextWrapper mobile={minTablet}>
          <Text
            color="blueGray"
            fontWeight={700}
            size={minTablet ? 38 : 26}
            style={{ marginBottom: minTablet ? 16 : 10 }}
          >
            {translate(translationKeys.aboutus.CTATitle)}
          </Text>
          <Text
            color="black"
            size={minTablet ? 16 : 14}
            style={{ marginBottom: minTablet ? 70 : 32 }}
          >
            {translate(translationKeys.aboutus.CTASubTitle)}
          </Text>
          <Button
            type="primary"
            onClick={createOffer}
            style={{ width: minTablet ? 360 : '100%', margin: '0 auto', height: 48 }}
          >
            {translate(translationKeys.aboutus.typesButton)}
          </Button>
        </TextWrapper>
      </Content>
    </ContentWrapper>
  );
};
